import { createStore } from 'zustand'

import { GenericalRecord } from '../../../../types/utilities'
import { excludeNilFilter } from '../../../../utils/lambda'
import { promiseNoop } from '../../../../utils/promise'

import { RemoteTableStoreOptions, RemoteTableStore } from './interface'

export const createRemoteTableStore = <
  T extends GenericalRecord,
  P extends GenericalRecord
>({
  containerRef,
  rowKey,
  searchForm
}: RemoteTableStoreOptions<T>) =>
  createStore<RemoteTableStore<T, P>>((set, get) => ({
    containerRef,
    rowKey,
    error: undefined,
    loading: false,
    data: [],
    pagination: {
      current: 1,
      pageSize: 20,
      total: 0,
      pages: 0
    },
    selectedRowKeys: [],
    selectedRows: [],
    setSelectedRows(selectedRows) {
      set({
        selectedRows,
        selectedRowKeys: selectedRows
          .filter(excludeNilFilter)
          .map(item => item[rowKey])
      })
    },
    searchForm,
    requestParams: {
      ...searchForm.initialValues,
      ...searchForm.values
    },
    setRequestParams(params) {
      set({ requestParams: params })
      get().searchForm.setValues(params)
    },
    _runAsync: promiseNoop,
    reload(config = {}) {
      // 不改变搜索条件只是单纯的重新加载数据时，保持 current 不变
      const mergedConfig = { resetPage: false, ...config }
      return get().request(get().requestParams, mergedConfig)
    },
    request(params, config) {
      const mergedRequestParams: any = {
        ...params
      }
      if (config?.resetPage !== false) {
        // 外界手动调用 request 时，默认将 current 设为 1
        mergedRequestParams.current = 1
      }
      return get().doRequest(mergedRequestParams)
    },
    doRequest(params) {
      const mergedRequestParams = {
        ...get().requestParams,
        ...params
      }
      get().setRequestParams(mergedRequestParams)
      return get()._runAsync(mergedRequestParams)
    }
  }))
